<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_exploration_intro')
}

const isOnMapSection = computed(() => {
  return route.path === '/map/galaxy'
})

const goToMap = () => {
  router.push('/map/galaxy')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/exploration.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.exploration.intro.greetings') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.exploration.intro.letBegin') }}
      </p>
      <p>
        {{ t('tutorial.exploration.intro.navigateToMap') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="white" class="hidden md:flex">
        {{ t('tutorial.exploration.intro.tipMinimize') }}
      </AlertBox>
      <AlertBox type="info" class="hidden md:flex">
        {{ t('tutorial.exploration.intro.clickMap') }}
      </AlertBox>
      <AlertBox type="white" class="sm:hidden">
        {{ t('tutorial.exploration.intro.tipMinimizeMobile') }}
      </AlertBox>
      <AlertBox type="info" class="md:hidden">
        {{ t('tutorial.exploration.intro.clickMapMobile') }}
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnMapSection" @click="goToMap" class="mr-2">
        {{ t('tutorial.exploration.intro.goToMap') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('common.actions.continue') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>